import { useState, useEffect, useCallback, useRef } from 'react';

/**
 * Hook to track page visibility state
 * Used to prevent unnecessary refetches when user switches tabs/apps and returns
 */
export const usePageVisibility = () => {
  const [isVisible, setIsVisible] = useState(!document.hidden);
  const [wasHidden, setWasHidden] = useState(false);
  const wasHiddenRef = useRef(false);

  useEffect(() => {
    const handleVisibilityChange = () => {
      const hidden = document.hidden;
      
      if (hidden) {
        wasHiddenRef.current = true;
        setWasHidden(true);
      }
      
      setIsVisible(!hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  const resetWasHidden = useCallback(() => {
    wasHiddenRef.current = false;
    setWasHidden(false);
  }, []);

  return { 
    isVisible, 
    wasHidden, 
    wasHiddenRef,
    resetWasHidden 
  };
};
